import { render } from "./Offering.vue?vue&type=template&id=62a1798c&scoped=true"
import script from "./Offering.vue?vue&type=script&lang=js"
export * from "./Offering.vue?vue&type=script&lang=js"

import "./Offering.vue?vue&type=style&index=0&id=62a1798c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a1798c"]])

export default __exports__